<template>
    <div class="home__container bg-base-300 h-2/3">
        <NavBar />

        <div class="grid place-items-baseline m-10 h-2/3">
            <div class="ui-mockup-phone max-w-5xl h-2/3">
                <div class="ui-camera"></div>
                <div class="ui-display">
                    <div class="main block h-fit md:flex justify-center bg-base-300 m-5">
                        <div>Try it now</div>
                        <div>temp</div>
                        <div class="fade-overlay w-full absolute bottom-0 left-0 h-2/3 bg-gradient-to-b from-transparent to-white"></div>
                        <button class="ui-btn ui-btn-primary ui-btn-lg purchase-button absolute bottom-64 left-1/2 transform -translate-x-1/2 px-4 py-2 rounded shadow-2xl">
                            Try it now for free!
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import NavBar from 'components/nav-bar.vue';

export default {
    name: 'Home',
    components: {
        NavBar,
    },
    data: () => ({}),
    created() {},
    methods: {},
};
</script>

<style scoped>
/* Adjustments might be needed if more specific customization is required that Tailwind doesn't cover */
.fade-overlay {
    z-index: 1; /* Ensuring overlay does not interfere with button interaction */
}

.main {
    min-height: 80vh; /* Ensure there's enough height for effective gradient display */
}

.purchase-button {
    z-index: 10; /* Ensuring button is above all other content for usability */
}
</style>
